<template>
  <crm-drawer
    key="search-branch"
    :visible="visible"
    @onClose="$emit('onCloseDrawerSwitchBranch')"
  >
    <template #header>
      <div class="search-box">
        <transition
          name="custom-classes-transition"
          enter-active-class="animate__animated animate__fadeIn animate__faster"
          leave-active-class="animate__animated animate__fadeOut animate__faster"
          mode="out-in"
        >
          <div v-if="!isShowSearch" class="search-bar">
            <p class="search-all-branch-text">
              {{ $t('components.home.branch-all') }} ({{ branchListActive.length }})
            </p>
            <i
              class="el-input__icon el-icon-search search-btn pr-2"
              @click="isShowSearch = true"
            />
          </div>
        </transition>
        <transition
          name="custom-classes-transition"
          enter-active-class="animate__animated animate__slideInRight animate__faster"
          leave-active-class="animate__animated animate__slideOutRight animate__faster"
          mode="out-in"
        >
          <el-input
            v-if="isShowSearch"
            :placeholder="$t('components.home.branch-search')"
            v-model="searchText"
          >
            <template #prefix>
              <i class="el-input__icon el-icon-search" />
            </template>
            <template #suffix>
              <i
                class="search-close-btn el-input__icon el-icon-error"
                @click="onCloseSearchInput"
              />
            </template>
          </el-input>
        </transition>
      </div>
    </template>
    <template #content>
      <el-row
        v-if="!isLoading && branchListWithSearch.length > 0"
        class="crm-branch-content"
      >
        <branch-item
          v-for="item in branchListWithSearch"
          :key="item.branchUUID"
          :branchInfo="item"
          class="crm-branch-items"
        />
      </el-row>
      <el-row v-else-if="!(isLoading || isError)">
        <nothing-to-see-here
          useSvg="search-no-data.svg"
          :mainText="$t('components.home.branch-not-found')"
          :subText="$t('components.home.try-another-search')"
        />
      </el-row>
      <el-row v-else-if="isLoading">
        <branch-item isLoading class="crm-branch-items" />
        <branch-item isLoading class="crm-branch-items" />
        <branch-item isLoading class="crm-branch-items" />
      </el-row>
      <el-row v-else>
        <nothing-to-see-here
          useImg="oops-error.webp"
          :mainText="$t('history.sorry')"
          :subText="$t('history.unable-retrieve')"
          @click-reload="fetchBranchList"
          haveReloadBtn
        />
      </el-row>
    </template>
  </crm-drawer>
</template>

<script>
import { mapActions } from "vuex";
import NothingToSeeHere from "@/components/NothingToSeeHere.vue";
const CrmDrawer = () => import("@/components/CrmDrawer.vue");
const BranchItem = () => import("@/components/home/BranchItem.vue");

export default {
  name: "BranchList",
  components: {
    CrmDrawer,
    BranchItem,
    NothingToSeeHere,
  },
  props: {
    visible: Boolean,
  },
  data() {
    return {
      isLoading: false,
      searchText: "",
      isShowSearch: false,
      isError: null,
      branchList: [],
    };
  },
  async mounted() {
    this.fetchBranchList();
  },
  methods: {
    ...mapActions({
      fetchBranchListAction: "branch/fetchBranchList",
    }),
    onCloseSearchInput() {
      this.isShowSearch = false;
      this.searchText = "";
    },
    async fetchBranchList() {
      this.isLoading = true;
      await this.fetchBranchListAction()
        .then((res) => {
          this.branchList = res
          this.isError = null;
        })
        .catch((error) => {
          this.isError = error;
        })
        .finally(() => {
          this.isLoading = false;
        });
      if(this.branchList.length > 0)
          this.branchList = await this.sortBranchByname(this.branchList)
    },
    async sortBranchByname(branchList){
      this.isLoading = true
      let th = [] , en = []
      branchList.forEach(item => {
        if(/^([a-zA-Z])/.test(item.branchName)) en.push(item)
        else th.push(item)
      });
      th.sort(function (a, b) {
        if (a.branchName < b.branchName) return -1;
        if (a.branchName > b.branchName) return 1;
        return 0;
      });
      en.sort(function (a, b) {
        if (a.branchName < b.branchName) return -1;
        if (a.branchName > b.branchName) return 1;
        return 0;
      });
      this.isLoading = false
      return await this.sortCloseBranch([...th,...en])
    },
    sortCloseBranch(data){
      let active= [], close =[]
      data.forEach(item => {
        if(item.disabledFlag) close.push(item)
        else active.push(item)
      });
      return [...active,...close]
    }
  },
  computed: {
    branchListActive() {
      if (!(this.isLoading || this.isError)) {
        return this.branchList;
      } else return [];
    },
    branchListWithSearch() {
      return this.branchListActive.filter((e) => {
        return e.branchName.toLowerCase().match(this.searchText.toLowerCase());
      });
    },
  },
};
</script>

<style scoped>
.crm-branch-items {
  margin-bottom: 12px;
}
.crm-branch-content {
  height: 100%;
}

.search-box {
  position: relative;
  height: 40px;
  overflow: hidden;
}
.search-bar {
  position: absolute;
  display: flex;
  width: 100%;
  align-items: center;
  color: var(--gray-1);
}
.search-all-branch-text {
  margin: 0;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 24px;
}
.search-btn {
  cursor: pointer;
  margin-left: auto;
  font-size: 24px;
}

.search-close-btn {
  cursor: pointer;
}
.search-close-btn:active {
  color: var(--label);
}
.search-close-btn:hover {
  color: var(--label);
}
</style>